import { Fragment, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Button from "../../components/Button";
import Card from "../../components/Card";
import Dropzone from "../../components/Dropzone";
import Loader from "../../components/Loader";
import Modal from "../../components/Modal";
import Table, { Td, Th } from "../../components/Table";
import { setInterface } from "../../redux/slices/interfaceSlice";
import service from "../../service";

import swal from "@sweetalert/with-react";
import BigLoader from "../../components/BigLoader";
import ReactSelect from "react-select";

export default function Category() {
  const dispatch = useDispatch();
  const [getLoading, setGetLoading] = useState(false);
  const [data, setData] = useState([]);
  const { control, handleSubmit, watch } = useForm();
  const _iconModal = useRef();
  const _deleteModal = useRef();
  const [id, setId] = useState(0);
  const [deleteId, setDeleteId] = useState(null);
  const [reassignId, setReassignId] = useState(null);
  const [hasContent, setHasContent] = useState(false);
  const [postLoading, setPostLoading] = useState(false);

  const getData = () => {
    setGetLoading(true);
    service
      .get("/api/category")
      .then((response) => {
        setGetLoading(false);
        setData(response.data);
      })
      .catch((e) => {
        setGetLoading(false);
      });
  };

  const changeIcon = ({ icon }) => {
    setPostLoading(true);
    const formData = new FormData();
    formData.append("icon", icon);

    service
      .put(`/api/category/${id}`, formData)
      .then(() => {
        setPostLoading(false);
        getData();
        swal("Berhasil", "Icon berhasil diganti", "success").then((value) => {
          if (value) {
            _iconModal.current.hide();
          }
        });
      })
      .catch(() => {
        setPostLoading(false);
      });
  };

  const deleteCategory = (e) => {
    e.preventDefault();
    if (hasContent && !reassignId) {
      swal(
        "Pilih kategori tujuan",
        "Silakan pilih kategori untuk memindahkan konten.",
        "warning"
      );
      return;
    }

    setPostLoading(true);
    const payload =
      reassignId && hasContent
        ? { move_to: Number(reassignId) }
        : undefined;
    service
      .delete(`/api/category/${deleteId}`, {
        data: payload,
      })
      .then(() => {
        setPostLoading(false);
        _deleteModal.current.hide();
        swal("Berhasil", "Kategori berhasil dihapus", "success");
        getData();
      })
      .catch((err) => {
        setPostLoading(false);
        const message =
          err.response?.data?.message ||
          "Gagal menghapus kategori. Coba lagi.";
        swal("Gagal", message, "error");
      });
  };

  useEffect(() => {
    dispatch(setInterface({ active: "Kategori", pageTitle: "Kategori" }));
    getData();
  }, [dispatch]);
  return (
    <Fragment>
      <Helmet>
        <title>Kategori</title>
      </Helmet>
      <Card>
        {getLoading ? (
          <div className="h-64 flex justify-center items-center flex-col">
            <Loader className="bg-black-100" />
            <span className="mt-3 text-black-300 text-sm">Memuat</span>
          </div>
        ) : data.length > 0 ? (
          <Table>
            <thead>
              <tr>
                <Th>NO</Th>
                <Th>NAMA</Th>
                <Th>KONTEN</Th>
                <Th>ICON</Th>
                <Th>AKSI</Th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={item.id || index}>
                  <Td className="text-center">{index + 1}</Td>
                  <Td>{item.name}</Td>
                  <Td className="text-center">{item.contents_count}</Td>
                  <Td>
                    <div className="flex justify-center">
                      {item.icon ? (
                        <img
                          src={process.env.REACT_APP_BASE_URL + item.icon}
                          className="w-8 h-8 object-contain"
                        />
                      ) : (
                        <span className="text-black-400 text-sm">
                          Tidak ada icon
                        </span>
                      )}
                    </div>
                  </Td>
                  <Td className="text-center">
                    <div className="flex justify-center gap-2">
                      <button
                        onClick={() => {
                          setId(item.id);
                          _iconModal.current.show();
                        }}
                        type="button"
                        className="py-1.5 px-3 rounded-sm border border-white-300 text-sm transition-colors hover:bg-primary-500 hover:border-primary-600 hover:text-white-100"
                      >
                        Ganti Icon
                      </button>
                      <button
                        onClick={() => {
                          setDeleteId(item.id);
                          setHasContent(item.contents_count > 0);
                          setReassignId(null);
                          _deleteModal.current.show();
                        }}
                        type="button"
                        className="py-1.5 px-3 rounded-sm border border-white-300 text-sm transition-colors hover:bg-red-200 hover:border-red-300 hover:text-white-100"
                      >
                        Hapus
                      </button>
                    </div>
                  </Td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div className="text-center flex flex-col justify-center items-center h-40 text-black-300">
            <p>Belum ada konten</p>
          </div>
        )}
      </Card>
      <Modal ref={_iconModal} title="Ganti Icon">
        <form onSubmit={handleSubmit(changeIcon)}>
          <Controller
            name="icon"
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange } }) => (
              <Dropzone
                containerClassName="mb-4"
                onChange={(accepted) => {
                  onChange(accepted[0]);
                }}
                dropzone={{ accept: "image/jpeg, image/png" }}
              />
            )}
          />
          {watch("icon") ? (
            <Fragment>
              <span className="text-sm font-semibold text-black-300 mb-2 block">Preview</span>
              <div className="flex justify-center mb-4">
                <img
                  src={URL.createObjectURL(watch("icon"))}
                  alt="Preview Icon"
                  className="w-28 h-28 object-cover"
                />
              </div>
            </Fragment>
          ) : null}
          <Button type="submit" color="blue" className="w-28">
            Upload
          </Button>
        </form>
      </Modal>
      <Modal ref={_deleteModal} title="Hapus Kategori">
        <form onSubmit={deleteCategory}>
          {hasContent ? (
            <Fragment>
              <p className="mb-3">
                Kategori ini memiliki konten. Pilih kategori tujuan untuk
                memindahkan konten sebelum menghapus.
              </p>
              <ReactSelect
                className="mb-4"
                classNamePrefix="react-select"
                options={data
                  .filter((cat) => cat.id !== deleteId)
                  .map((cat) => ({ value: cat.id, label: cat.name }))}
                value={
                  reassignId
                    ? {
                        value: reassignId,
                        label:
                          data.find((cat) => cat.id === reassignId)?.name || "",
                      }
                    : null
                }
                onChange={(selected) => {
                  setReassignId(selected?.value || null);
                }}
                placeholder="Pilih kategori tujuan"
              />
            </Fragment>
          ) : (
            <p className="mb-3">
              Kategori tidak memiliki konten. Kategori akan dihapus permanen.
            </p>
          )}
          <div className="flex justify-end">
            <Button
              type="button"
              className="mr-3"
              onClick={() => _deleteModal.current.hide()}
            >
              Batal
            </Button>
            <Button type="submit" color="red">
              Hapus
            </Button>
          </div>
        </form>
      </Modal>
      {postLoading && <BigLoader />}
    </Fragment>
  );
}
